// TODO -- see if we can combine with ChangeEmail component.
// That is, make a single component where properties are passed in
// to determine if it's for password or email.

// https://mui.com/material-ui/react-dialog/#form-dialogs

import * as React from 'react';

import EmailIcon from '@mui/icons-material/Email';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import TokenService from "src/services/token";
import { useNavigate } from "react-router-dom";

import {
    setUserMessage
} from 'src/reducers/basicReducer';
import { useDispatch } from 'react-redux'

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useFormik } from "formik";

import * as yup from "yup";

import { change_email } from "src/services/auth"

const validationSchema = yup.object({
    email_old: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    email_new: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string()
        .min(8, 'Password should be of minimum 8 characters length')
        .required('Password is required'),
});


export default function ChangeEmail() {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [message, setMessage] = React.useState("");

    const handleClose = () => {
        setOpen(false);
        setMessage("");
    };


    const formik = useFormik({

        initialValues: {
            email_old: '',
            email_new: '',
            password: ''
        },
        validationSchema: validationSchema,
        // TODO - consider if we should have two password fields (and check that they match)
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.log(values);

            change_email(values.email_old, values.email_new, values.password).then(
                () => {
                    // XXX dispatch(setUserMessage("Registration successful. Please log in."));
                    // XXX navigate("/login");
                    setMessage("Email change successful");
                    // TODO - consider if we should log out users at this point

                    // TODO - consider if we should clear all form fields at this point (probably, lol)
                    // https://bobbyhadz.com/blog/react-clear-input-after-submit
                },
                (error) => {
                    console.log("Email change failed!!!");
                    console.log(error);


                    // resMessage is for if we want to automatically determine the issue to display
                    // const resMessage =
                    //     (error.response &&
                    //         error.response.data &&
                    //         error.response.data.message) ||
                    //     error.message ||
                    //     error.toString();
                    // setLoading(false);
                    if (error.response.data.status === "bad current email or password") {
                        setMessage("Error: invalid credentials or new email already exists");
                    } else {
                        setMessage("Unknown error");
                    }
                }
            );
        }
    });











    return (




        <div>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
                Open form dialog
            </Button> */}
            <ListItemButton onClick={handleClickOpen}>
                <ListItemIcon>
                    <EmailIcon />
                </ListItemIcon>
                <ListItemText primary="Change email" />
            </ListItemButton>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Change email address</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To change your email address, please fill out this form.
                    </DialogContentText>

                    <Box
                        component="form"
                        id="myform"
                        onSubmit={formik.handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        {/* TODO: think about how to reserve space for helperText
                        so the form does not expand and contract as we work
                        on it https://github.com/mui/material-ui/issues/13646 */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email_old"
                            name="email_old"
                            label="Current email Address"
                            value={formik.values.email_old}
                            onChange={formik.handleChange}
                            error={formik.touched.email_old && Boolean(formik.errors.email_old)}
                            helperText={formik.touched.email_old && formik.errors.email_old}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email_new"
                            name="email_new"
                            label="New email Address"
                            value={formik.values.email_new}
                            onChange={formik.handleChange}
                            error={formik.touched.email_new && Boolean(formik.errors.email_new)}
                            helperText={formik.touched.email_new && formik.errors.email_new}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password"
                            name="password"
                            label="Current password"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                        />

                        {/* TODO: move style to css! */}

                        {/* {message && (
                            <div className="form-group">
                                <div className="alert alert-danger" role="alert" style={{ color: 'red' }}>
                                    {message}
                                </div>
                            </div>
                        )} */}

                        {/* https://stackoverflow.com/questions/63721055/react-hooks-remember-me-checkbox-in-login-form-not-working */}
                        {/* <FormControlLabel
                            control={<Checkbox id="remember" name="remember" value={formik.values.remember} onChange={formik.handleChange} color="primary" />}
                            label="Remember me"
                        /> */}
                        {/* <Button
                            type="submit"
                            onClick={() => {
                                // erase user message if new submission is attempted
                                // https://stackoverflow.com/questions/61962001/how-to-make-the-formik-call-a-function-when-the-form-is-invalid
                                // dispatch(setUserMessage(""))
                            }}
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button> */}
                    </Box>



                </DialogContent>
                {/* https://stackoverflow.com/questions/40881616/how-to-submit-the-form-by-material-ui-dialog-using-reactjs */}
                <DialogActions>

                    {/* TODO - elsewhere redux message is wrapped in another div (???) Maybe drop the outer div? */}
                    {message && (
                        <div className="alert alert-danger" role="alert" style={{ flex: '1 0 0', color: 'red' }}>
                            {message}
                        </div>
                    )}

                    <Button variant="contained" type="submit" form="myform">Submit</Button>
                    <Button variant="contained" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}